import './ContentPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import classNames from 'classnames';
import update from 'immutability-helper';
import ReduxInfiniteScroll from 'redux-infinite-scroll';

import Card from 'components/Card';
import ChecklistEditModal from './modals/ChecklistEditModal';
import ChecklistAddItemModal from './modals/ChecklistAddItemModal';
import Content from 'components/Content';
import ContentDetailsModal from './modals/ContentDetailsModal';
import ContentHeader from 'components/ContentHeader';
import ContentOptions from 'components/ContentOptions';
import ContentOptionsMenu from 'components/ContentOptionsMenu';
import CreateMenu from 'components/CreateMenu'
import FileUploadEditModal from './modals/FileUploadEditModal';
import LoadingSpinner from 'components/LoadingSpinner';
import ModalConfirm from 'components/ModalConfirm';
import ModalPreview from 'components/ModalPreview';
import Search from 'components/Search';

import { closeConfirmModal, closeModal, closePreviewModal, openConfirmModal, openModal, openPreviewModalAndSetContentToPreview, updateTitle } from 'containers/App/store/actions';
import { setAssignment } from 'containers/AssignmentsPage/store/actions';
import { emptyAssignment } from 'containers/AssignmentsPage/store/reducers';
import { clearContentSingle, clearContentToPreview, emptyContent, deleteContent, getAssignmentsAndSetContentSingle, getContent, postContentFile, postPutContent, setContentSingle, updateContent, updateSearchTerm, updateFileToUpload, uploadThumbnailsAndPostPutChecklist } from './store/actions';
import { FILTER_BY_OPTIONS, SORT_BY_OPTIONS } from './constants';
import { MODALS } from 'utils/constants';

class ContentPage extends React.Component {
    constructor() {
        super();

        this.createMenuLinks = [
            {
                icon: 'document',
                mobileLinkUrlString: '/content',
                onClick: this._openContentModal.bind(this, null, MODALS.CONTENT_EDIT_FILE_UPLOAD, 'document'),
                text: 'File Upload'
            }/*, {
                icon: 'image',
                mobileLinkUrlString: 'dontshow',
                onClick: this._openContentModal.bind(this, null, MODALS.CONTENT_EDIT_FILE_UPLOAD, 'image'),
                text: 'Image'
            }, {
                icon: 'document',
                mobileLinkUrlString: 'dontshow',
                onClick: this._openContentModal.bind(this, null, MODALS.CONTENT_EDIT_FILE_UPLOAD, 'document'),
                text: 'Document'
            }, {
                icon: 'web',
                mobileLinkUrlString: 'dontshow',
                onClick: this._openContentModal.bind(this, null, MODALS.CONTENT_EDIT_FILE_UPLOAD, 'web'),
                text: 'Web Link'
            }*/, {
                icon: 'checklist',
                mobileLinkUrlString: '/content',
                onClick: this._openContentModal.bind(this, null, MODALS.CONTENT_EDIT_CHECKLIST, 'checklist'),
                text: 'Checklist'
            }/*, {
                icon: 'elearning',
                mobileLinkUrlString: 'dontshow',
                onClick: this._openContentModal.bind(this, null, MODALS.CONTENT_EDIT_FILE_UPLOAD, 'elearning'),
                text: 'E-Learning'
            }, {
                mobileLinkUrlString: '/content',
                onClick: this._openContentModal.bind(this, null, MODALS.CONTENT_EDIT_FILE_UPLOAD, null),
                showOnDesktop: false
            }*/
        ]

        this.oldContentPiece = {};

        this.state = {
            itemEditIndex: null
        };
    }

    componentWillMount() {
        this.props.emptyContent();
        this.props.updateTitle('Content');
    }

    _cancelDelete() {
        this.props.closeConfirmModal();
        if(this.props.app.modal === '') {
            this.props.clearContentSingle();
        }
    }

    createAssignmentFromContentItem(contentPiece) {
        let newAssignmentObj = update(emptyAssignment, {
            contents: { $push: [contentPiece] }
        });

        this.props.setAssignment(newAssignmentObj);
        this.props.changeLocation('/assignments/new');
    }

    _loadContent() {
        if(this.props.content.isFetching === false) {
            this.props.getContent();
        }
    }

    _confirmDelete(contentPiece) {
        this.props.setContentSingle(contentPiece);
        this.props.openConfirmModal(MODALS.CONTENT_DELETE_CONFIRM);
    }

    _handleDeleteContent() {
        this.props.deleteContent(() => {
            this.props.closeConfirmModal();
            this.props.closeModal();
        });
    }

    /**
     * @desc    Dispatches actions necessary to filter and GET content
     * @param   filterBy
     */
    _handleFilter(filterBy) {
        let newContentObj = update(this.props.content, {
            pageNumber: {$set: 0},
            filterBy: {$set: filterBy},
            searchTerm: {$set: ''},
            hasMore: {$set: true},
            all: {$set: []}
        });
        this.props.updateContent(newContentObj);
        this.props.getContent();
    }

    handleSaveChecklist() {
        this.props.uploadThumbnailsAndPostPutChecklist(() => {
            this.props.openModal(MODALS.CONTENT_DETAILS);
        });
    }

    handleSaveFileUpload() {
        let itemExists = this.props.content.single.id != null;

        if(this.props.content.fileToUpload != null) {
            this.props.postContentFile(() => {
                if(itemExists === true) {
                    this.props.openModal(MODALS.CONTENT_DETAILS);
                } else {
                    this.props.clearContentSingle();
                    this.props.closeModal();
                    this.props.updateFileToUpload(null);
                }
            });
        } else {
            this.props.postPutContent(() => {
                if(itemExists === true) {
                    this.props.openModal(MODALS.CONTENT_DETAILS);
                } else {
                    this.props.clearContentSingle();
                    this.props.closeModal();
                }
            });
        }
    }

    _handleSearch() {
        let newContentObj = update(this.props.content, {
            pageNumber: {$set: 0},
            hasMore: {$set: true},
            all: {$set: []}
        });
        this.props.updateContent(newContentObj);
        this.props.getContent();
    }

    /**
     * @desc    Dispatches actions necessary to sort and GET content
     * @param   sortBy
     * @param   sortDirection
     */
    _handleSort(sortBy, sortDirection) {
        if(sortBy !== this.props.content.sortBy || sortDirection !== this.props.content.sortDirection) {
            let newContentObj = update(this.props.content, {
                pageNumber: {$set: 0},
                sortBy: {$set: sortBy},
                sortDirection: {$set: sortDirection},
                searchTerm: {$set: ''},
                hasMore: {$set: true},
                all: {$set: []}
            });
            this.props.updateContent(newContentObj);
            this.props.getContent();
        }
    }

    _handleFileSelectedToUpload(file) {
        //console.log(file.constructor === File);
        this.props.updateFileToUpload(file);
    }

    _closeContentEditModal() {
        if(this.props.content.single.id != null) {
            this.props.setContentSingle(this.oldContentPiece);
            this.props.openModal(MODALS.CONTENT_DETAILS);
        } else {
            this.props.clearContentSingle();
            this.props.closeModal();
            this.oldContentPiece = {};
        }
        this._handleFileSelectedToUpload(null);
    }

    _openContentModal(contentPiece, modal, type) {
        if(contentPiece != null) {
            if (contentPiece.assignmentIds == null || contentPiece.assignmentIds.length === 0) {
                this.props.setContentSingle(contentPiece);
            } else {
                this.props.getAssignmentsAndSetContentSingle(contentPiece);
            }
        } else {
            contentPiece = {type};
            if(type === 'checklist') {
                contentPiece.items = [];
                contentPiece.isInLibrary = true;
            }

            this.props.setContentSingle(contentPiece);
        }
        this.oldContentPiece = JSON.parse(JSON.stringify(contentPiece));
        this.props.openModal(modal);
    }

    _openPreviewModal(contentSet) {
        //console.log('contentSet', contentSet);
        this.props.openPreviewModalAndSetContentToPreview(contentSet);
    }

    render() {
        let { clearContentSingle, clearContentToPreview, closeModal, closePreviewModal, content, openModal, setContentSingle } = this.props;
        return (
            <Content>
                <ContentHeader>
                    <Search handleSearchTermChange={this.props.updateSearchTerm}
                            handleSearch={this._handleSearch.bind(this)}
                            value={content.searchTerm} />
                    <ContentOptions>
                        <ContentOptionsMenu icon="sort"
                                            disabled={content.searchTerm !== ''}>
                            {SORT_BY_OPTIONS.map((option) => {
                                return (
                                    <div role="button"
                                         className={classNames({'active': content.searchTerm === '' && option.sortBy === content.sortBy && option.sortDirection === content.sortDirection})}
                                         onClick={this._handleSort.bind(this, option.sortBy, option.sortDirection)}
                                         key={option.key}>
                                        {option.text}
                                    </div>
                                )
                            })}
                        </ContentOptionsMenu>
                        <ContentOptionsMenu icon="filter"
                                            disabled={content.searchTerm !== ''}>
                            {FILTER_BY_OPTIONS.map((option) => {
                                return (
                                    <div role="button"
                                         className={classNames({'active': content.searchTerm === '' && option.filterBy === content.filterBy})}
                                         onClick={() => {
                                             if(content.searchTerm !== '' || option.filterBy !== content.filterBy) {
                                                this._handleFilter(option.filterBy)
                                             }
                                         }}
                                         key={option.key}>
                                        {option.text}
                                    </div>
                                )
                            })}
                        </ContentOptionsMenu>
                    </ContentOptions>
                </ContentHeader>

                <ReduxInfiniteScroll elementIsScrollable={false}
                                     hasMore={this.props.content.hasMore}
                                     loadMore={this._loadContent.bind(this)}
                                     loadingMore={this.props.content.isFetching === true}
                                     className="cards"
                                     loader={<LoadingSpinner />}>
                    {content.all.map((contentPiece) => {
                        return <Card createAssignment={this.createAssignmentFromContentItem.bind(this, contentPiece)}
                                     item={contentPiece}
                                     key={contentPiece.id}
                                     handleDelete={this._confirmDelete.bind(this, contentPiece)}
                                     onClick={this._openContentModal.bind(this, contentPiece, MODALS.CONTENT_DETAILS)}
                                     openEditModal={this._openContentModal.bind(this, contentPiece, contentPiece.type === 'file' ? MODALS.CONTENT_EDIT_FILE_UPLOAD : MODALS.CONTENT_EDIT_CHECKLIST)}/>
                    })}
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    <div className="card empty"></div>
                    {content.hasMore === false ? (
                            <div className="cards__no-more">
                                No more content to load.
                            </div>
                        ) : null}
                </ReduxInfiniteScroll>

                <CreateMenu links={this.createMenuLinks} />

                <ContentDetailsModal closeModal={() => {
                                         clearContentSingle();
                                         closeModal();
                                         this._handleFileSelectedToUpload(null);
                                         this.oldContentPiece = {};
                                     }}
                                     deleteContent={this._confirmDelete.bind(this)}
                                     isSaving={content.isSaving}
                                     openModal={openModal.bind(this)}
                                     openPreviewModal={this._openPreviewModal.bind(this)}
                                     show={this.props.app.modal === MODALS.CONTENT_DETAILS}
                                     contentPiece={content.single}
                                     adminEmail={this.props.auth.adminEmail} />

                <FileUploadEditModal closeModal={() => {
                                      clearContentSingle();
                                      closeModal();
                                      this._handleFileSelectedToUpload(null);
                                      this.oldContentPiece = {};
                                  }}
                                  cancelModal={this._closeContentEditModal.bind(this)}
                                  contentError={content.error}
                                  contentPiece={content.single}
                                  fileToUpload={content.fileToUpload}
                                  handleFileSelectedToUpload={this._handleFileSelectedToUpload.bind(this)}
                                  isSaving={content.isSaving}
                                  saveContentSingle={this.handleSaveFileUpload.bind(this)}
                                  setContentSingle={setContentSingle.bind(this)}
                                  show={this.props.app.modal === MODALS.CONTENT_EDIT_FILE_UPLOAD}
                                  adminEmail={this.props.auth.adminEmail} />

                <ChecklistEditModal
                    closeModal={() => {
                        clearContentSingle();
                        closeModal();
                        this._handleFileSelectedToUpload(null);
                        this.oldContentPiece = {};
                    }}
                    cancelModal={this._closeContentEditModal.bind(this)}
                    contentPiece={content.single}
                    fileToUpload={content.fileToUpload}
                    handleThumbnailSelectedToUpload={this._handleFileSelectedToUpload.bind(this)}
                    isSaving={content.isSaving}
                    openAddChecklistItemModal={(itemEditIndex) => {
                        this.setState({itemEditIndex})
                        this.props.openModal(MODALS.CONTENT_EDIT_CHECKLIST_ADD_ITEM)
                    }}
                    saveContentSingle={this.handleSaveChecklist.bind(this)}
                    setContentSingle={setContentSingle.bind(this)}
                    show={this.props.app.modal === MODALS.CONTENT_EDIT_CHECKLIST}
                />

                <ChecklistAddItemModal
                    closeModal={() => {
                        this.props.openModal(MODALS.CONTENT_EDIT_CHECKLIST);
                        this.setState({itemEditIndex: null})
                    }}
                    contentPiece={content.single}
                    itemEditIndex={this.state.itemEditIndex}
                    setContentSingle={setContentSingle.bind(this)}
                    show={this.props.app.modal === MODALS.CONTENT_EDIT_CHECKLIST_ADD_ITEM}
                />

                <ModalPreview contentPiece={content.contentPieceToPreview}
                              handleClose={() => {
                                  closePreviewModal();
                                  clearContentToPreview();
                              }}
                              show={this.props.app.modalPreview === true} />

                {/*Modal for confirming delete content*/}
                <ModalConfirm show={this.props.app.modalConfirm === MODALS.CONTENT_DELETE_CONFIRM}
                              cancelAction={this._cancelDelete.bind(this)}
                              confirmAction={this._handleDeleteContent.bind(this)}
                              confirmText="Remove"
                              disabled={content.isSaving}
                              text="This action will permanently remove your content from the list. If the content is currently in use it will remain attached to its assignment(s)."
                              title="Remove?" />
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        auth: state.auth,
        content: state.content,
        users: state.users
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearContentSingle: () => dispatch(clearContentSingle()),
        clearContentToPreview: () => dispatch(clearContentToPreview()),
        closeConfirmModal: () => dispatch(closeConfirmModal()),
        closeModal: () => dispatch(closeModal()),
        closePreviewModal: () => dispatch(closePreviewModal()),
        deleteContent: (callback) => dispatch(deleteContent(callback)),
        emptyContent: () => dispatch(emptyContent()),
        getAssignmentsAndSetContentSingle: (contentObj) => dispatch(getAssignmentsAndSetContentSingle(contentObj)),
        getContent: () => dispatch(getContent()),
        openConfirmModal: (modalNameString) => dispatch(openConfirmModal(modalNameString)),
        openModal: (modalNameString) => dispatch(openModal(modalNameString)),
        openPreviewModalAndSetContentToPreview: (contentSet) => dispatch(openPreviewModalAndSetContentToPreview(contentSet)),
        postContentFile: (callback) => dispatch(postContentFile(callback)),
        postPutContent: (callback) => dispatch(postPutContent(callback)),
        setAssignment: (assignmentObj) => dispatch(setAssignment(assignmentObj)),
        setContentSingle: (contentObj) => dispatch(setContentSingle(contentObj)),
        updateContent: (contentObj) => dispatch(updateContent(contentObj)),
        updateSearchTerm: (searchTerm) => dispatch(updateSearchTerm(searchTerm)),
        updateFileToUpload: (file) => dispatch(updateFileToUpload(file)),
        updateTitle: (title) => dispatch(updateTitle(title)),
        uploadThumbnailsAndPostPutChecklist: (callback) => dispatch(uploadThumbnailsAndPostPutChecklist(callback))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage);



// WEBPACK FOOTER //
// ./src/containers/ContentPage/index.js